import * as types from './types';

export default {
  updateCanvasStatesSaga: (payload) => ({ type: types.UPDATE_CANVAS_STATE_SAGA, payload }),
  undoSaga: (payload) => ({ type: types.UNDO_SAGA, payload }),
  redoSaga: (payload) => ({ type: types.REDO_SAGA, payload }),
};
